import { Component, inject } from '@angular/core';
import { LoadingService } from '../../../core/services/loading.service';

@Component({
  selector: 'app-loading-overlay',
  standalone: true,
  template: `
    @if (loading.isLoading()) {
      <div class="loading-overlay" role="alert" aria-busy="true" aria-live="polite">
        <div class="loading-overlay__box">
          <div class="loading-overlay__spinner"></div>
          <div class="loading-overlay__label">Saving…</div>
        </div>
      </div>
    }
  `,
  styles: [`
    .loading-overlay {
      position: fixed;
      inset: 0;
      z-index: var(--z-modal);
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.25);
      backdrop-filter: blur(1px);
    }

    .loading-overlay__box {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;
      padding: 22px 28px;
      border-radius: var(--radius-md);
      border: 1px solid var(--border-default);
      background: var(--bg-elevated);
      box-shadow: var(--shadow-lg);
    }

    .loading-overlay__spinner {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: 3px solid var(--border-default);
      border-top-color: var(--accent);
      animation: loading-overlay-spin 0.7s linear infinite;
    }

    .loading-overlay__label {
      font-size: 0.8125rem;
      font-weight: 600;
      color: var(--text-secondary);
    }

    @keyframes loading-overlay-spin {
      to { transform: rotate(360deg); }
    }
  `],
})
export class LoadingOverlayComponent {
  loading = inject(LoadingService);
}
